module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_5012.9b77598e.png";